import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";
import type { ChatMessageDetailOutputDto } from "web_myplann/Infrastructure/ApiOld/Api";
import { isImageMimeType } from "web_myplann/Shared/Utils/isImageMimeType";

type ChatMessageDto = Omit<ChatMessageDetailOutputDto, "attachments"> & {
	attachments?: unknown;
};

type RawAttachment = {
	id?: number;
	type?: string;
	mimeType?: string;
	fileName?: string;
	name?: string | null;
};

const toAttachmentArray = (attachments: unknown): RawAttachment[] => {
	if (!attachments) return [];
	if (Array.isArray(attachments)) return attachments as RawAttachment[];
	return [attachments as RawAttachment];
};

export const mapChatMessage = (dto: ChatMessageDto): ChatMessageView => ({
	id: dto.id,
	content: dto.content ?? "",
	direction: dto.is_mine === 1 ? "sender" : "recipient",
	isRead: dto.is_read === 1,
	createdAt: new Date(dto.created_at),
	fromName: dto.from_name ?? "",
	attachments: toAttachmentArray(dto.attachments)
		.filter(
			(attachment): attachment is Required<RawAttachment> =>
				typeof attachment.id === "number",
		)
		.map((attachment) => ({
			id: attachment.id,
			type: attachment.type,
			mimeType: attachment.mimeType,
			fileName: attachment.name ?? attachment.fileName,
			isImage: isImageMimeType(attachment.mimeType),
		})),
});
